<sam-app-component>
  <sam-app-toolbar ngProjectAs="toolbar-section">
    <div ngProjectAs="left-section" class="toolbar-brand" aria-label="Application">
      <img src="assets/icons/logo.png" alt="Logo" class="toolbar-favicon" />
      <span class="toolbar-brand-label">GEOXP</span>
    </div>

    <div ngProjectAs="wifi-icon" aria-hidden="true"></div>

    <div ngProjectAs="middle-section">

      <button mat-button type="button" (click)="navigateHome()" [class.accent-force]="this.url().includes('home')">
        <mat-icon>home</mat-icon> {{ 'home' | translate }}
      </button>

      <button mat-button type="button" routerLink="/search" [class.accent-force]="this.url().startsWith('/search')">
        <mat-icon>search</mat-icon> {{ 'search' | translate }}
      </button>

      <button mat-button type="button" routerLink="/inventory" [class.accent-force]="this.url().startsWith('/inventory')">
        <mat-icon>inventory_2</mat-icon> {{ 'inventory' | translate }}
      </button>

      <button mat-button type="button" routerLink="/areas" [class.accent-force]="this.url().startsWith('/areas')">
        <mat-icon>map</mat-icon> {{ 'areas' | translate }}
      </button>

      <button mat-button [matMenuTriggerFor]="pairing" [class.accent-force]="this.url().includes('pairing') && !this.url().includes('expeditions')">
        <mat-icon>build_circle</mat-icon> {{ 'pair' | translate }}
      </button>
      <mat-menu #pairing="matMenu">
        @if (canPair()) {
          <button mat-menu-item [routerLink]="['/pairing-pieces']" routerLinkActive>
            <mat-icon>link</mat-icon> {{ 'pairingPiecesForm.title' | translate }}
          </button>
        }
        @if (canUnPair()) {
          <button mat-menu-item [routerLink]="['/unpairing-pieces']" routerLinkActive>
            <mat-icon>link_off</mat-icon>
            {{ 'unpairingPiecesForm.title' | translate }}
          </button>
        }
        @if (canPair() && canUnPair()) {
          <button mat-menu-item [routerLink]="['/move-pairing']" routerLinkActive>
            <mat-icon>move_up</mat-icon>
            {{ 'movePairing' | translate }}
          </button>
        }
        @if (canSeeTagsPaired()) {
          <button mat-menu-item [routerLink]="['/tags-paired']" routerLinkActive>
            <mat-icon>track_changes</mat-icon>
            {{ 'Permissions.Balises.ViewBalisesAvecPiece' | translate }}
          </button>
        }
        @if (canManageDemandesApproTags()) {
          <button mat-menu-item [routerLink]="['/demandes-approvisionnement-tags']" routerLinkActive>
            <mat-icon>add_task</mat-icon>
            {{ 'DemandesApproTags' | translate }}
          </button>
        }
      </mat-menu>

      <button mat-button [matMenuTriggerFor]="expedition" [class.accent-force]="this.url().includes('expeditions')">
        <mat-icon>local_shipping</mat-icon> {{ 'expeditions.expedition' | translate }}
      </button>
      <mat-menu #expedition="matMenu">
        @if (searchExpedition()) {
          <button mat-menu-item [routerLink]="['/expeditions/dpe']" routerLinkActive>
            <mat-icon>local_shipping</mat-icon> {{ 'expeditions.dpe' | translate }}
          </button>
        }
        @if (canPrintPackageLabel()) {
          <button mat-menu-item [routerLink]="['/expeditions/printing-parcel-label']" routerLinkActive>
            <mat-icon>print</mat-icon> {{ 'impressionEtiquette.menu' | translate }}
          </button>
        }
        @if (searchExpedition()) {
          <button mat-menu-item [routerLink]="['/expeditions/unpairing-parcel']" routerLinkActive>
            <mat-icon>link_off</mat-icon>
            {{ 'expeditions.link_offPackage' | translate }}
          </button>
        }
      </mat-menu>

      @if (canPair() && canUnPair()) {
        <button
          mat-button
          type="button"
          [routerLink]="['/parts-to-move']"
          [class.accent-force]="this.url().includes('parts-to-move')">
          <mat-icon>find_replace</mat-icon> {{ 'inventory' | translate }}
        </button>
      }

      <button
        mat-button
        [matMenuTriggerFor]="quarantaine"
        [class.accent-force]="this.url().includes('quarantine') || this.url().includes('anomalies')">
        <mat-icon>texture</mat-icon> {{ 'quarantaine' | translate }}
      </button>
      <mat-menu #quarantaine="matMenu">
        <button mat-menu-item [routerLink]="['/inventory/defective-quarantine-parts']" routerLinkActive>
          <mat-icon>category</mat-icon> {{ 'piecesAnomalie' | translate }}
        </button>
        <button mat-menu-item [routerLink]="['/inventory/all-quarantine-parts']" routerLinkActive>
          <mat-icon>grain</mat-icon> {{ 'zoneQuarantaine' | translate }}
        </button>
        <button mat-menu-item [routerLink]="['/inventory/transports-anomalies']" routerLinkActive>
          <mat-icon>emergency_home</mat-icon> {{ 'transportsAnomalies' | translate }}
        </button>
      </mat-menu>

      @if (canAccessAdmin()) { 
        <button
          mat-button
          [matMenuTriggerFor]="settings"
          [class.accent-force]="this.url().includes('settings')"
          [class.no-connection]="!isConnected()">
          <mat-icon>settings</mat-icon> {{ 'settings' | translate }}
        </button>
        <mat-menu #settings="matMenu">
          @if (canAccessArticles()) {
            <button mat-menu-item [routerLink]="['/settings/articles']" routerLinkActive>
              <mat-icon>article</mat-icon>
              {{ 'articles' | translate }}
            </button>
          }

          @if (canAccessComments()) {
            <button mat-menu-item [routerLink]="['/settings/comments']" routerLinkActive>
              <mat-icon>comment</mat-icon>
              {{ 'comments' | translate }}
            </button>
          }

          @if (managePriority() || canAccessInterruptReasons()) {
            <button mat-menu-item [matMenuTriggerFor]="expeditionsSettings">
              <mat-icon>local_shipping</mat-icon>
              {{ 'expeditions.expedition' | translate }}
            </button>
          }

          <mat-menu #expeditionsSettings="matMenu">
            @if (canAccessInterruptReasons()) {
              <button
                mat-menu-item
                [routerLink]="['/settings/exp/interrupt-reasons']"
                routerLinkActive>
                <mat-icon>new_releases</mat-icon>
                {{ 'interruptReasons' | translate }}
              </button>
            }
            @if (managePriority()) {
              <button
                mat-menu-item
                [routerLink]="['/settings/exp/priorities']"
                routerLinkActive>
                <mat-icon>priority_high</mat-icon>
                {{ 'expeditions.priorities' | translate }}
              </button>
            }
          </mat-menu>

          @if (searchExpedition() || canAccessInterruptReasons()) {
            <button
              mat-menu-item
              [routerLink]="['/mahvis']"
              routerLinkActive>
              <mat-icon>settings</mat-icon>
              {{ 'touareg.commercialName' | translate }}
            </button>
          }

          <samv2-toolbar-settings-elements [showIncoming]="true"></samv2-toolbar-settings-elements>
        </mat-menu>
      }
    
    </div>

        <span class="fill-remaining-space"></span>
        <div>
          <app-touareg-control-trigger></app-touareg-control-trigger>
        </div>
  </sam-app-toolbar>
</sam-app-component>